import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import style from './styles/style.module.css';
import { Field, reduxForm, Form, change } from 'redux-form';
import { PrimaryButton, TimePicker, DLRichTextEditor } from 'appSrc/components/UI';
import { FormTextField, FormToggle } from 'appSrc/components/UI/ReduxForm';
import { validateWebUrl, DL_DRIVE_REGEX } from 'appSrc/utils';
import moment from 'moment-timezone';

const validate = {
    required: ( value ) => ( ( value == null || !/\S/.test( value ) ) ? 'Required' : undefined ),
    url: ( value ) => ( !!value && !validateWebUrl( value ) ? 'Invalid URL': undefined ),
};


class ScheduleBlockForm extends PureComponent {
    constructor( props ) {
        super( props );

        var initState = {};

        if( this.props.initialValues.start_time ) {
            initState.start_time = moment( this.props.initialValues.start_time );
        } else {
            initState.start_time = moment( this.props.initialValues.run_date, 'MM/DD/YYYY' ).hour( 9 ).minute( 0 ).second( 0 ).millisecond( 0 );
        }

        if( this.props.initialValues.end_time ) {
            initState.end_time = moment( this.props.initialValues.end_time );
        } else {
            initState.end_time = moment( this.props.initialValues.run_date, 'MM/DD/YYYY' ).hour( 9 ).minute( 0 ).second( 0 ).millisecond( 0 );
        }

        this.state = {
            ...initState,
            duration: this.props.initialValues.duration || '00:00:00',
            description: this.props.initialValues.description || '',
            task: this.props.task || 'editing',
        };
    }
    setTimeValue = ( name, date ) => {
        var update = {};
        update[ name ] = date;
        if( name == 'end_time' ) {
            // calc duration
            var diff = moment.duration( update[ 'end_time' ].diff( this.state.start_time ) );
            update[ 'duration' ] = moment.utc( diff.as('milliseconds') ).format('HH:mm:ss');
            this.props.changeFieldValue( 'duration', update[ 'duration' ] );
        }
        this.setState( update );
    }
    updateDescription = ( value ) => {
        this.setState( { description: value } );
        this.props.changeFieldValue( 'description', value );
    }
    submit = ( values ) => {
        var cover_image = values.cover_image;
        if( DL_DRIVE_REGEX.test( cover_image ) ) {
            var id = cover_image.match( DL_DRIVE_REGEX )[ 1 ];
            cover_image = 'https://drive.google.com/a/desirelist.com/thumbnail?id=' + id;
        }

        var ret = {
            id: values.id,
            start_time: this.state.start_time.format(),
            end_time: this.state.end_time.format(),
            category: values.category,
            should_persist: values.should_persist,
            sponser: values.sponser,
            sponser_link: values.sponser_link,
            donation_link: values.donation_link,
            is_hidden: values.is_hidden,
            video: {
                block_id: values.id,
                id: values.video_id,
                title: values.title,
                duration: this.state.duration,
                description: this.state.description,
                uri: values.uri,
                is_live: values.is_live,
                pro_name: values.pro_name,
                pro_profession: values.pro_profession,
                pro_email: values.pro_email,
                related_content_link: values.related_content_link,
                cover_image: cover_image,
            },
        };

        this.props.onSubmit( ret );
    }



    render() {
        const { handleSubmit } = this.props;
        const { start_time, end_time } = this.state;

        const timeProps = {
            use12Hours: true,
            showSecond: false,
            format: 'hh:mm A',
        };

        return (
            <Form className={ style.form }
            onSubmit={ handleSubmit( this.submit ) }>
                <div className={ style.grid }>
                    <div>
                        <div className={ style.timeField } >
                            <div className={ style.fieldTitle }>Run Date:</div>
                            <p>{ this.props.initialValues.run_date }</p>
                        </div>

                        <Field
                        id="duration"
                        name="duration"
                        label="Duration:"
                        fullWidth
                        component={ FormTextField } />

                        <div className={ style.timeField } >
                            <div className={ style.fieldTitle }>Start Time:</div>
                            <TimePicker { ...timeProps } value={ start_time }
                            onChange={ ( value ) => { this.setTimeValue( 'start_time', value ); } } />
                        </div>

                        <div className={ style.timeField } >
                            <div className={ style.fieldTitle }>End Time:</div>
                            <TimePicker { ...timeProps } value={ end_time }
                            onChange={ ( value ) => { this.setTimeValue( 'end_time', value ); } } />
                        </div>

                        <Field
                        id="category"
                        name="category"
                        label="Category"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="is_hidden"
                        name="is_hidden"
                        label="Hide on Schedule?"
                        style={ { marginBottom: '15px', zIndex: 0 } }
                        component={ FormToggle } />
                    </div>

                    <div>
                        <Field
                        id="title"
                        name="title"
                        label="Title"
                        fullWidth
                        component={ FormTextField } />

                        <div>
                            <DLRichTextEditor label="Description"
                            value={ this.state.description } onChange={ this.updateDescription } />
                        </div>

                        <Field
                        id="uri"
                        name="uri"
                        label="Video Link*"
                        fullWidth
                        required
                        validate={ [ validate.required, validate.url ] }
                        component={ FormTextField } />

                        <Field
                        id="cover_image"
                        name="cover_image"
                        label="Cover Image"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />

                        <Field
                        id="is_live"
                        name="is_live"
                        label="Live?"
                        style={ { marginBottom: '15px', zIndex: 0 } }
                        component={ FormToggle } />

                        <Field
                        id="should_persist"
                        name="should_persist"
                        label="Persist?"
                        style={ { marginBottom: '15px', zIndex: 0 } }
                        component={ FormToggle } />
                    </div>

                    <div>
                        <Field
                        id="pro_name"
                        name="pro_name"
                        label="Pro"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="pro_profession"
                        name="pro_profession"
                        label="Pro Title"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="pro_email"
                        name="pro_email"
                        label="Pro Email"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="donation_link"
                        name="donation_link"
                        label="Donation Link"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />

                        <Field
                        id="related_content_link"
                        name="related_content_link"
                        label="Related Content Link"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />

                        <div className={ style.spacer } />

                        <Field
                        id="sponser"
                        name="sponser"
                        label="Sponser"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="sponser_link"
                        name="sponser_link"
                        label="Sponser Link"
                        fullWidth
                        validate={ [ validate.url ] }
                        component={ FormTextField } />
                    </div>
                </div>

                <PrimaryButton
                label="Submit"
                type="submit"
                fullWidth
                style={ { marginTop: '15px', zIndex: 0 } }/>
            </Form>
        );
    }
}
ScheduleBlockForm.defaultProps = {
    onSubmit: () => {},
};

ScheduleBlockForm = reduxForm( {
    form: 'ScheduleBlockForm',
} )( ScheduleBlockForm );

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'ScheduleBlockForm', field, value ) );
        },
    };
};


export default connect( null, mapDispatchToProps )( ScheduleBlockForm );
